import {
  ADD_BANKING,
  ADD_BANKING_SUCCESS,
  ADD_BANKING_FAILURE,
} from "../actionTypes";

export const addBanking = (payload) => ({
  type: ADD_BANKING,
  payload,
});

export const addBankingSuccess = (payload) => ({
  type: ADD_BANKING_SUCCESS,
  payload,
});

export const addBankingFailure = () => ({
  type: ADD_BANKING_FAILURE,
});
